import * as React from 'react';
import {element, oneOf, string, func, shape, number, arrayOf, bool} from 'prop-types';

import {HABIT_TYPE} from '../../features/Habit/constants';
import './style.css';

const getHabitIcon = function(type, color){
  switch(type){
    case HABIT_TYPE.DO:
      return <div className={`inline-block text rounded-full p-0 text-lg w-6 text-${color}`}>
        &#10003;
      </div>
    case HABIT_TYPE.DONT:
      return <div className={`inline-block rounded-full p-0 text-lg w-6 text-${color}`}>
        &#215;
      </div>
  }
}

export default function HabitItem(props){

  let {name, type, color} = props.habit;

  return <div className="flex items-center habit-item">
    {getHabitIcon(type, color)}
    <span>
      {name}
    </span>
    {props.onDelete ?
      <div className="ml-2 text-sm text-red-800 cursor-pointer habit-item--delete-habit" onClick={_ => props.onDelete(props.habit)}>
        &#215;
      </div>
      : null
    }
  </div>
}


HabitItem.propTypes = {
  habit: shape({
    completed: bool,
    name: string, 
    type: oneOf([HABIT_TYPE.DO, HABIT_TYPE.DONT]),
    color: string,
    uuid: string,
    id: number,
    reccurence: arrayOf(number)
  }),
  onDelete: func
}
